import { Link } from "react-router-dom";
import { siteInfo, siteStats } from "@/mocks/site";

const tickerItems = [
  "花絮现场",
  "路透速览",
  "侧拍角度",
  "彩蛋收集",
  "候场切片",
  "NG 合集",
  "灯光机位",
  "道具细节",
];

export default function Hero() {
  return (
    <section className="relative -mt-16 md:-mt-20 overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20film%20set%20scene%20with%20warm%20amber%20spotlights%2C%20deep%20crimson%20velvet%20curtains%2C%20soft%20bokeh%20light%20orbs%2C%20analog%20film%20grain%2C%20moody%20editorial%20atmosphere%2C%20minimalist%20composition%2C%20high%20detail&width=1600&height=900&seq=chigua-hero-01&orientation=landscape"
          alt="暖色调布光下的片场氛围背景"
          title="吃瓜片场 私拍吃瓜花絮路透合集"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/65 to-foreground-950/85" />
      </div>

      <div className="relative w-full px-4 md:px-8 pt-32 md:pt-44 pb-16 md:pb-24">
        <div className="max-w-3xl mx-auto flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 text-background-50 text-xs tracking-[0.2em] animate-fade-up">
            <i className="ri-sparkling-line text-accent-400" aria-hidden="true" />
            私拍吃瓜 · 花絮路透合集站
          </span>

          <h1 className="font-heading text-4xl md:text-6xl font-black text-background-50 mt-6 tracking-wide animate-fade-up">
            {siteInfo.name}
          </h1>

          <p
            className="text-base md:text-lg text-background-100/90 leading-relaxed mt-6 max-w-2xl animate-fade-up"
            style={{ animationDelay: "0.1s" }}
          >
            私拍吃瓜花絮、私拍吃瓜路透、私拍吃瓜侧拍、私拍吃瓜彩蛋与私拍吃瓜候场片段，
            全部整理成独立合集。想看正片之外的路透细节、侧拍说法或备料内容，从这里直接进，按分类浏览更方便。
          </p>

          <div
            className="flex flex-col sm:flex-row items-center gap-3 mt-9 w-full sm:w-auto animate-fade-up"
            style={{ animationDelay: "0.2s" }}
          >
            <Link
              to="/collections"
              className="w-full sm:w-auto px-7 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors text-center whitespace-nowrap"
            >
              进入合集大厅
            </Link>
            <Link
              to="/collections?cat=huaxu"
              className="w-full sm:w-auto px-7 py-3.5 rounded-md border border-background-50/40 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors text-center whitespace-nowrap"
            >
              先看花絮现场
            </Link>
          </div>

          <dl
            className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-8 mt-14 w-full animate-fade-up"
            style={{ animationDelay: "0.3s" }}
          >
            {siteStats.map((stat) => (
              <div key={stat.label} className="flex flex-col items-center">
                <dt className="font-heading text-2xl md:text-3xl font-bold text-accent-400">
                  {stat.value}
                </dt>
                <dd className="text-xs md:text-sm text-background-100/80 mt-1.5">
                  {stat.label}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>

      <div className="relative border-t border-background-50/15 py-3.5 overflow-hidden">
        <div className="flex w-max animate-marquee">
          {[0, 1].map((round) => (
            <div key={round} className="flex items-center shrink-0">
              {tickerItems.map((item) => (
                <span
                  key={`${round}-${item}`}
                  className="flex items-center gap-3 px-6 text-xs md:text-sm text-background-100/70 whitespace-nowrap"
                >
                  <i className="ri-film-line text-accent-500" aria-hidden="true" />
                  {item}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}